import React from 'react';
import 'twin.macro';
import { filterEmpty } from '@/utils/index';
import FooterLI from './FooterLI';
import * as footerTypes from '../../types/FooterTypes.type';

export default function FooterTerms(footerProps: footerTypes.FooterListProps) {
  const { items } = footerProps;
  const listItems = filterEmpty(items).map((item) => (
    <FooterLI
      key={item.text}
      text={item.text}
      href={item.url}
      header={false}
      bullet
    />
  ));
  return (
    <div tw="mx-auto w-full  max-w-full border-y border-gray-mid py-5 lg:max-w-7xl">
      <div tw="px-4 ">
        <ul tw="flex flex-wrap justify-around text-[.75rem]">{listItems}</ul>
      </div>
      {' '}
    </div>
  );
}
